if (!customElements.get("sht-country-switcher")) {
  class CountrySwitcher extends SHTCustomComponent {
    constructor() {
      super();
      this.sub_elms = {
        country_code_field: this.$(".js-country-switcher-country-code-field"),
        country_btn: this.$(".js-country-switcher-btn"),
        country_list: this.$(".js-country-switcher-country-list"),
        country_link_items: this.$$(".js-country-switcher-country-item-link"),
        country_form: this.$(".js-country-switcher-form")
      };
      this.sub_elms.country_btn.addEventListener("click", this.toggleCountrySwitcher.bind(this));
      this.sub_elms.country_btn.addEventListener("focusout", e => {
        this.contains(e.relatedTarget) || this.hideCountryListPanel();
      });
      this.sub_elms.country_link_items.forEach(a => {
        a.addEventListener("click", this.onLinkItemClickHandler.bind(this));
      });
      this.addEventListener("keyup", this.onKeyUpCountrySwitcherHandler.bind(this));
    }
    toggleCountrySwitcher() {
      this.sub_elms.country_btn.focus(); this.toggleCountryList();
    }
    hideCountryListPanel() {
      this.sub_elms.country_btn.setAttribute("aria-expanded","false");
      this.sub_elms.country_list.classList.remove("is-open");
    }
    toggleCountryList() {
      this.sub_elms.country_btn.focus();
      if (this.sub_elms.country_list.classList.contains("is-open")) {
        this.sub_elms.country_list.classList.remove("is-open");
        this.sub_elms.country_btn.setAttribute("aria-expanded","false");
      } else {
        this.sub_elms.country_list.classList.add("is-open");
        this.sub_elms.country_btn.setAttribute("aria-expanded","true");
      }
    }
    onKeyUpCountrySwitcherHandler(e) {
      if (e && e.code && e.code.toUpperCase() === "ESCAPE") {
        this.sub_elms.country_btn.focus(); this.hideCountryListPanel();
      }
    }
    onLinkItemClickHandler(e) {
      e.preventDefault();
      this.sub_elms.country_code_field.value = e.currentTarget.dataset.value;
      const rt = this.sub_elms.country_form.querySelector('[name="return_to"]');
      if (rt) rt.value = window.location.pathname;
      this.sub_elms.country_form.submit();
    }
  }
  customElements.define("sht-country-switcher", CountrySwitcher);
}